import SectionTitle from '@/components/common/SectionTitle';
import CategoryPageContext from '@/context/CategoryPageContext';
import { Container } from '@pwskills/rachnaui';
import React, { useContext } from 'react';
import SuccessStoryCards from '@/components/common/SuccessStoryCards';

const SuccessStories = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const stories = categoryDetails?.successStories;

  return (
    <section className="!bg-white">
      <Container className="py-8 medium:pt-14 medium:pb-[52px] medium:!px-8 large:!px-20 flex flex-col  bg-white gap-6 large:!gap-14">
        <SectionTitle upperText="We Are" lowerText="Creating Success Stories" />
        {stories && <SuccessStoryCards successStories={stories} />}
      </Container>
    </section>
  );
};

export default SuccessStories;
